import _ from 'lodash';
import {
  createFetchReviewsUrl,
  DATA_VERSION_ENDPOINT,
  createReviewServerHeaders,
} from './fetch-helpers';
import { ReviewsApiConfig } from '../typings/reviews';

interface FetchDataVersionOptions {
  reviewsHostData?: ReviewsApiConfig;
  readonly apiKeyContent?: string;
}

export class ReviewsDataVersionFetchError extends Error {
  public constructor(message: string) {
    super('FetchDataVersion: ' + message);
  }
}

export async function fetchReviewsDataVersion({
  reviewsHostData,
  apiKeyContent,
}: FetchDataVersionOptions): Promise<string> {
  const VERSION_PROP = 'current_dv';
  const requestUrl = createFetchReviewsUrl(
    reviewsHostData,
    'dataVersionPath',
    undefined,
    DATA_VERSION_ENDPOINT,
  );
  const { apiEnvironmentKey } = reviewsHostData?.customConfig as any;
  const requestHeader = createReviewServerHeaders(
    apiKeyContent || apiEnvironmentKey,
  );

  const request = await fetch(requestUrl, { headers: requestHeader });
  const response = await request.json();

  if (request.status >= 500)
    throw new ReviewsDataVersionFetchError(response.message);

  if (!response[VERSION_PROP])
    throw new ReviewsDataVersionFetchError(
      'Invalid response structure, NO CURRENT DATA VERSION',
    );

  return response['current_dv'];
}
